import React from 'react';
import PropTypes from 'prop-types';

/**
 * Some items have additional flags, eg "new" or "alcohol free". This component displays them if they exist.
 *
 * @function
 * @param       {array} flags zero or more array of flag objects.
 * @constructor
 */
function Flags({ flags, isForBaste }) {
    if (!flags || !flags.length) {
        return null;
    }

    return (
        <>
            {flags.map((flag, idx) => {
                if (flag === 'NEW_RECIPE') {
                    return null;
                }

                let name = (flag || '').toLowerCase().replace(/_/gi, ' ');

                const className = name.replace(/ /gi, '');

                if (flag === 'ITS_BACK') {
                    name = 'it\'s back';
                }

                if (flag === 'LIMITED_TIME_ONLY') {
                    name = 'limited time';
                }

                return (
                    <i key={idx} className={`flag ${className}${isForBaste ? ' is-for-baste' : ''}`}>
                        {name}
                    </i>
                );
            })}
        </>
    );
}

export { Flags };

Flags.propTypes = {
    flags: PropTypes.arrayOf(PropTypes.string),
    isForBaste: PropTypes.bool
};
